import styled from 'styled-components';

export const ShowMoreButton = styled.button`
  width: 100%;
  ${({ theme }) => theme.kallisto.mixins.font('Body')};
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  border: 0;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  text-align: left;
  background-color: white;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
`;
